import LoadingAnimation from "@/assets/LoadingAnimation.json";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";

interface LoaderProps {
  message?: string;
  percentage?: any;
  enableScroll?: any;
}

const Loader = ({ message, percentage, enableScroll }: LoaderProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const loaderExists = document.getElementById("global-loader");

    if (loaderExists) return;

    setShouldRender(true);

    const originalOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;

      if (enableScroll) {
        document.body.style.overflow = "auto";
        document.documentElement.style.overflow = "auto";
      }
    };
  }, []);

  if (!shouldRender) return null;

  return (
    <div id="global-loader" className="fixed inset-0 z-50 bg-black/80">
      <div className="fixed left-[50%] top-[50%] z-50 flex translate-x-[-50%] translate-y-[-50%] flex-col items-center gap-4">
        {message && (
          <div className="text-center text-[14px] text-white">
            <span>Please wait!</span>
            <p>{message}</p>
          </div>
        )}
        <div className="flex h-[100px] w-[100px] items-center justify-center rounded-lg border border-neutral-200 bg-white shadow-lg">
          <Lottie
            animationData={LoadingAnimation}
            loop={true}
            autoplay={true}
            className="mx-auto my-10 h-auto w-20"
          />
        </div>
        {percentage > 0 && (
          <div className="text-center text-[14px] text-white transition-all duration-300 ease-in-out">
            {percentage}%
          </div>
        )}
      </div>
    </div>
  );
};

export default Loader;
